import FileManager from "./FileManager";

function App() {
    
  return (
    <div className="bg-white dark:bg-gray-900 w-auto">
      <h1 className="text-xl font-bold px-4 p-2 dark:text-white">Manage Files</h1>
      <FileManager token={localStorage.getItem("authToken")} />
    </div>
  );
}

export default App;
